<template>
  <svg width="25" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M21.672 1H3.328C2.042 1 1 2.022 1 3.282v10.436C1 14.978 2.042 16 3.328 16h18.344C22.958 16 24 14.978 24 13.718V3.282C24 2.022 22.958 1 21.672 1ZM18 9l6 4M8 8l-7 5"
      />
      <path d="m2 2 9.026 9.333c.86.89 2.258.89 3.117 0L23 2.18" />
    </g>
  </svg>
</template>
